<script setup>
import { getUpcomingLeaves } from '@/components/Admin/LeaveSummary/services/leave-summary.service.ts';
import LeaveHistory from '@/components/Admin/LeaveSummary/LeaveHistory.vue';

export default {
    components: { LeaveHistory },
    data() {
        return {
            employees: [],
            columns: [
                { title: 'Leave Type', key: 'status' },
                { title: 'Date', key: 'clockInTime' },
            ],
        };
    },
    async mounted() {
        const { data } = await getUpcomingLeaves();
        this.employees = data;
    },
    methods: {
        showAlert(e, employee) {
            this.$refs.leaveHistory.showModal(employee._id);
            e.stopPropagation();
        },
    },
};
</script>

<template>
    <div>
        <LeaveHistory ref="leaveHistory" />
        <Collapse>
            <Panel v-for="employee in employees" :key="employee._id._id">
                <Button @click="(e) => showAlert(e, employee._id)">{{ employee._id.name }}</Button>
                <template #content> <Table :columns="columns" :data="employee.leaves"></Table></template>
            </Panel>
        </Collapse>
    </div>
</template>

<style scoped lang="scss"></style>
